import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Tchek } from '../model/tchek';
import { TchekOldService } from './tchek-old.service';
import { UserService } from './user.service';

@Injectable()
export class NotificationService {
  private newTcheksSource = new BehaviorSubject<Tchek[]>([]);
  currentNewTcheks = this.newTcheksSource.asObservable();

  private statusSource = new BehaviorSubject<boolean>(true);
  currentStatus = this.statusSource.asObservable();

  constructor(
    private _userService: UserService,
    private _tchekService: TchekOldService
  ) {
    /* if (this._userService.isLoggedIn()) {
      this._tchekService.getNewTcheks().subscribe(
        data => this.newTcheksSource.next(data),
        error => console.error(error)
      );
    }

    if (this._userService.isLoggedIn()) {
      this._tchekService.getStatus().subscribe(
        data => {
          let isOn = true;
          if(data.status=="0"){
            isOn=false
          }
          this.statusSource.next(isOn);
        },
        error => {
          console.error(error);
        }
      );
    }*/
  }

  changeNewTcheks(newTcheks: Tchek[]) {
    this.newTcheksSource.next(newTcheks);
  }

  changeStatus(status: boolean) {
    this.statusSource.next(status);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/notification.service.ts